var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaqsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18C4.0374 18 0 13.9626 0 9C0 4.0374 4.0374 0 9 0C13.9626 0 18 4.0374 18 9C18 13.9626 13.9626 18 9 18ZM9 0.9C4.53366 0.9 0.9 4.53366 0.9 9C0.9 13.4663 4.53366 17.1 9 17.1C13.4663 17.1 17.1 13.4663 17.1 9C17.1 4.53366 13.4663 0.9 9 0.9Z",
    fill: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61663 11.8535C8.36805 11.8535 8.16663 11.6521 8.16663 11.4035V10.706C8.16663 9.35224 8.99194 8.74222 9.65506 8.2519C10.2577 7.8064 10.7336 7.45432 10.7336 6.63064C10.7336 5.5663 10.0572 4.87852 9.01029 4.87852C7.81221 4.87852 7.26646 5.85826 7.26646 6.76852C7.26646 7.0171 7.06504 7.21852 6.81646 7.21852C6.56788 7.21852 6.36646 7.0171 6.36646 6.76852C6.36646 5.38198 7.27456 3.97852 9.01029 3.97852C10.5549 3.97852 11.6336 5.06914 11.6336 6.63064C11.6336 7.90828 10.8332 8.50012 10.19 8.97568C9.56236 9.43972 9.06645 9.8062 9.06645 10.706V11.4035C9.06663 11.6521 8.86503 11.8535 8.61663 11.8535Z",
    fill: "#F9F9F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60527 13.5758C8.8538 13.5758 9.05527 13.3743 9.05527 13.1258C9.05527 12.8773 8.8538 12.6758 8.60527 12.6758C8.35675 12.6758 8.15527 12.8773 8.15527 13.1258C8.15527 13.3743 8.35675 13.5758 8.60527 13.5758Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqsIcon);
export default __webpack_public_path__ + "static/media/faqsIcon.08b36b395e3cd58efb0157fa1f45699f.svg";
export { ForwardRef as ReactComponent };